import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=89bfd4e2&scoped=true"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./RoleSwitcher.vue?vue&type=style&index=0&id=89bfd4e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bfd4e2",
  null
  
)

export default component.exports